import { FC } from 'react';
import classNames from 'classnames';
import { IconButton, Tooltip } from '@lambdacurry/component-library';
import { MedusaProductVariant } from 'lib/home/generated/types/api';
import { useSaveFavoritePreferenceMutation } from 'lib/home/generated/queries';

export interface FavoriteButtonProps {
  className?: string;
  meal: MedusaProductVariant;
  onProductVariantUpdate: (item: MedusaProductVariant) => void;
}

export const FavoriteButton: FC<FavoriteButtonProps> = ({ className, meal, onProductVariantUpdate }) => {
  const { mutate: mutateFavoritePreference } = useSaveFavoritePreferenceMutation({
    onSuccess: ({ saveFavoritePreference }) => {
      if (onProductVariantUpdate) onProductVariantUpdate({ ...meal, variant_preference: saveFavoritePreference });
    }
  });

  const { variant_preference } = meal || {};
  const { favorite } = variant_preference || {};
  const favoriteIcon = favorite ? 'heartFilled' : 'heart';

  return (
    <Tooltip title={`${favorite ? 'Remove From' : 'Add To'} Favorites`}>
      <IconButton
        aria-label={`${favorite ? 'remove' : 'add'} meal to favorites`}
        className={classNames({ '!text-primary': favorite }, className)}
        data-cy={`favorite-btn-${favoriteIcon}`}
        icon={favoriteIcon}
        onClick={() =>
          mutateFavoritePreference({
            saveFavoritePreference: {
              product_variant_id: meal.id,
              favorite: !favorite
            }
          })
        }
      />
    </Tooltip>
  );
};
